var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"calculation-tooltip"},[_c('span',{staticClass:"glyphicon glyphicon-info-sign calculation-tooltip__icon"}),_vm._v(" "),_c('span',{staticClass:"calculation-tooltip__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }